
import React from 'react';
import { useDispatch, useSelector  } from 'react-redux';

import { useToken } from '../../project';

import { getDataModelDefinition } from '../reducers'
import { getActions } from '../sagas';

export default function useDataModelDefinition(dataProjectId) {

    const dispatch = useDispatch();
    const dataActions = getActions(dispatch);

    const dataModelDefinition = useSelector(state => getDataModelDefinition(state.data));
    const token = useToken();

    React.useEffect(() => {
        if (dataProjectId && !dataModelDefinition.dataModelDefinition && !dataModelDefinition.loading) {
            dataActions.getDataModelDefinition(token, dataProjectId);
        }
        return () => {
            // nop;
        };
    }, [dataProjectId]);

    return dataModelDefinition;
}
